<template>
    <div>
        <p class="headline">
            <v-icon style="margin-top:-5px;">fa-microphone</v-icon> Manage
            <small>Message Playlist</small>
        </p>
        <v-breadcrumbs :items="items">
            <template v-slot:item="props">
                <v-icon v-if="props.item.icon" style="color:#fff;">{{props.item.icon}}</v-icon>
                <v-breadcrumbs-item
                @click.prevent="props.item.href"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <v-card tile class="mt-4">
            <v-card-title>Message Playlists
                <v-spacer></v-spacer>
                <v-text-field
                    class="mr-4"
                    style="max-width: 350px;"
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            <v-btn  color="primary ma-3" tile @click.stop="newMessage">Create Message Playlist</v-btn>
            </v-card-title>

            <v-data-table
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
                dense
                :search="search"
                :headers="headers"
                :items="playlists"
                :items-per-page="20"
                item-key="id"
                class="elevation-1"
                :footer-props="{
                    itemsPerPageOptions:[10,20,30,50,100,-1]
                }"
                >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)">
                    edit
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)">
                    delete
                  </v-icon>
                </template>
                <template v-slot:[`item.interval`]="{item}">
                    <p> {{item.interval}} min</p>
                </template>

                <template v-slot:expanded-item="{headers, item}">
                    <td :colspan="headers.length" class="pa-4">
                        <v-data-table
                            dense
                            :headers="messagesHeader"
                            hide-default-footer
                            :items="item.messages"
                            class="elevation-1"
                            >
                            <template v-slot:[`item.av_duration`]="{item}">
                                <span>
                                    {{getHRF(item.av_duration)}}
                                </span>
                            </template>
                        </v-data-table>
                    </td>
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                    {{ formatedDate(item.updated_at) }}
                </template>

            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" persistent max-width="900">
            <v-card tile>
                <v-card-title class="pl-8" v-if="!isUploading">{{dialogTitle}}</v-card-title>
                <v-card-text>
                    <v-form ref="messageForm">
                         <v-col>
                            <v-text-field 
                                hide-details
                                label="Message Playlist Name"
                                :rules="[
                                (v) => !!v || 'This field is required.'
                                ]"
                                dense
                                outlined
                                v-model="editedItem.name"
                                prepend-icon="attachment"
                                ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field 
                                label="Created by"
                                dense
                                outlined
                                hide-details
                                :rules="[
                                (v)=> !!v || 'This field is required.'
                                ]"
                                v-model="editedItem.uploaded_by"
                                prepend-icon="person"
                                readonly
                                ></v-text-field>
                        </v-col>
                        <v-col>
                        <p>Messages</p>
                           <v-row v-for="(message,index) in editedItem.messages" :key="messageIndex+index" :class="'message'+message.id">
                                <v-col cols="12" md="5">
                                   <v-select
                                   hide-details
                                   item-value="id"
                                   @change="messageChange(message)"
                                   dense
                                   outlined
                                   v-model="message.id"
                                   :items="audioFiles"
                                   item-text="stored_file_name" 
                                   label="Select Message"></v-select>
                                </v-col>

                                <v-col cols="12" md="3">
                                   <input type="hidden" v-model="message.message_length"/>
                                   <v-text-field
                                   hide-details
                                   readonly
                                    outlined
                                    v-model="message.message_length_display"
                                    dense
                                    label="Message Length"></v-text-field>
                                </v-col>
                              
                                <v-col cols="12" md="2">
                                   <v-text-field
                                   prepend-inner-icon="remove"
                                   hide-details
                                   @click:prepend-inner="downVolume(message)"
                                   dense
                                   outlined
                                   class="volume-container"
                                   v-model.number="message.volume"
                                   append-icon="add"
                                   @click:append="upVolume(message)"
                                   :rules="[
                                   (v) => (!isNaN(parseInt(v)) && v >= 0 && v <= 100) || 'Number has to be between 0-100',
                                   (v) => (Number.isInteger(v)) || 'Number has to be an integral'
                                   ]"
                                   label="Volume"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                   <v-btn outlined @click="removePlaylistItem(message)" v-show="editedItem.messages.length > 1">Delete</v-btn>
                                </v-col>
                           </v-row>
                       </v-col>
                    </v-form>

                    <v-row
                        v-if="isUploading"
                        class="fill-height"
                        align-content="center"
                        justify="center">
                        <v-col
                        class="subtitle-1 text-center"
                        cols="12">
                        Your message is uploading...
                        </v-col>
                        <v-col cols="6">
                        <v-progress-linear
                            color="primary accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                        </v-col>
                    </v-row>
                    <v-row v-if="haveBlankMessage">
                        <v-col>
                            <p class="pl-4 mb-0" style="color: red;" >You can't add multiple item with blank message box. Please select a message in the box.</p>
                        </v-col>
                    </v-row>
                    <v-row v-if="!validPlaylist">
                        <v-col>
                            <p class="pl-4 mb-0" style="color: red;" >A playlist with a blank message box cannot be saved. Please delete the blank message box or select a message in the box.</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions isUploading>
                    <v-text-field
                    hide-details
                    class="mr-3"
                    min="3"
                    max="120"
                    outlined
                    type="number"
                    label="Interval between messages (between 3 and 120 minutes)"
                    dense
                    :rules="[
                    (v)=> !!v || 'This field is required.',
                    (v)=> (!isNaN(parseInt(v)) && v >= 3 && v <= 120) || 'Number has to be between 3 and 120',
                    (v)=> (Number.isInteger(v)) || 'Number has to be an integral'
                    ]"
                    v-model.number="editedItem.interval">
                    </v-text-field>
                    <v-btn @click="newPlaylistItem" color="primary" tile>Add Message</v-btn>
                    <v-btn color="warning" @click="close" tile>Close</v-btn>
                    <v-btn color="primary" tile class="mr-4" @click.prevent="save" :disabled="isUploading">Save Message Playlist</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog 
            max-width="400"
            v-model="deleteDialog">
            <v-card tile>
                <v-card-title>Are you sure?</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <p class="title">Do you want to delete this playlist?</p>
                    <div v-if="shouldDeleteItem" class="user-info">
                        <p class="mb-1">Playlist Name: {{shouldDeleteItem.original_name}}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    
                    <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
                    <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
                    
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from './axios'
import moment from 'moment'
export default {
    data(){
        return {
            validPlaylist: 1,
            haveBlankMessage: 0,
            messageIndex: 1,
            singleExpand:true,
            expanded: [],
            playlistDuration:0,
            audioFiles:[],
            fileName: '',
            isUploading: false,
            search: null,
            playlists: [],
            dialog: false,
            dialogTitle:'Add Message Playlist',
            messagesHeader:[
                {text: 'Message Description', value: 'stored_file_name'},
                {text: 'Length (Min)', value: 'av_duration'}
            ],
            items: [
                {
                text: "Message Playlists",
                disabled: true,
                href: '#',
                icon:'fa-microphone'
                }
            ],
            editedItem:{
                id:0,
                name:'',
                uploaded_by: this.$store.getters.getName,
                interval: 3,
                messages: [],
                created_at: '',
                updated_at: ''
            },
            defaultItem:{
                id:0,
                name: '',
                uploaded_by: this.$store.getters.getName,
                interval: 3,
                messages: [],
                created_at: '',
                updated_at: ''
            },
            editedIndex:-1,
            deleteDialog: false,
            deletePlaylistDialog: false,
            isConfirmDelete: false,
            shouldDeleteItem: null,
        }
    },
    methods:{
        formatedDate(date){
            return moment(date).format('MM-DD-YYYY')
        },
        getFormatedDuration(){
            let durationArray = String(this.playlistDuration).split('.')
            if(durationArray.length > 1){
                if(durationArray[0].length == 1){
                    return '0'+durationArray[0]+':'+durationArray[1].substring(0,2)
                }else{
                    return durationArray[0]+':'+durationArray[1].substring(0,2)
                }
            }
        },
        getLength(item){
            let mlen = 0
            let slen = 0
            let len = 0

            if(item.messages.length > 0){
                for (let index = 0; index < item.messages.length; index++) {
                    if(item.messages[index].av_duration){
                        let durationArray = item.messages[index].av_duration.split('.')
                        mlen += parseInt(durationArray[0])
                        slen += parseFloat(0+'.'+durationArray[1]) 
                    }
                }
            }

            if(slen > .59){
                mlen += slen / .60
            }

            let second = slen % .60
            return mlen +':'+ String(second).split('.')[1].substring(0,2)

        },
        newPlaylistItem(){
            
            if(this.editedItem.messages[this.editedItem.messages.length - 1].id == 0){
                    this.haveBlankMessage = 1
                    let el = document.getElementsByClassName('message0')
                    el[0].classList.add('without-message')
                    return 
            }else{
                this.haveBlankMessage = 0
            }

            let item = {id: 0, volume: 100}
            this.editedItem.messages.push(item)
        },
        removePlaylistItem(item){
            this.validPlaylist= 1
            this.haveBlankMessage= 0
            let index = this.editedItem.messages.indexOf(item)
            this.editedItem.messages.splice(index,1)
            this.playlistDuration = 0
            this.editedItem.messages.forEach(message=>{
                let af = this.audioFiles.filter(element=>{
                    return element.id == message.id
                })

                if(af[0])
                    this.playlistDuration += parseFloat(af[0].av_duration)
                
            })

            // if(this.editedItem.duration > 0)
            //    this.editedItem.duration = this.getFormatedDuration()
        },
        upVolume(item){
            let index = this.editedItem.messages.indexOf(item)
            let volume = parseInt(this.editedItem.messages[index].volume)
            if( volume <= 95){
                volume += 5
            }
            this.editedItem.messages[index].volume = volume
            this.messageIndex++
        },
        downVolume(item){
            let index = this.editedItem.messages.indexOf(item)
            let volume = parseInt(this.editedItem.messages[index].volume)
            if(volume >= 5){
                volume -= 5
            }
            this.editedItem.messages[index].volume = volume
            this.messageIndex++
        },
        getHRF(item){ //get human readable format
            var min = item.split(".")[0]
            var sec = item.split(".")[1]
            return min +' min ' + sec.substring(0,2) + ' secs'
        },
        messageChange(item){
            this.haveBlankMessage = 0
            this.validPlaylist = 1
            let index = this.editedItem.messages.indexOf(item)
            this.editedItem.messages[index].id = item.id
            this.playlistDuration = 0
            this.editedItem.messages.forEach(message=>{
                let messageIndex = this.editedItem.messages.indexOf(message)
                let af = this.audioFiles.filter(element=>{
                    return element.id == message.id
                })

                if(af[0]){
                    this.playlistDuration += parseFloat(af[0].av_duration)
                }

                this.editedItem.messages[messageIndex].message_length = parseFloat(af[0].av_duration)
                var min = af[0].av_duration.split(".")[0]
                var sec = af[0].av_duration.split(".")[1]
                this.editedItem.messages[messageIndex].message_length_display = min +' min ' + sec.substring(0,2) + ' secs'
            })  
        },
        newMessage(){
            this.dialog = true
            let item = {id: 0, volume:100}
            this.editedItem.messages = []
            this.editedItem.messages.push(item)
            this.editedItem.uploaded_by = this.$store.getters.getName
        },
        editItem(item){
            this.dialogTitle = 'Edit Message Playlist'
            this.editedIndex = this.playlists.indexOf(item)
            this.editedItem = Object.assign({},item)
            if(this.editedItem.messages.length == 0){
                let item = {id: 0, volume: 100}
                this.editedItem.messages.push(item)
            }else{
                this.editedItem.messages.forEach(element => {
                    element['volume'] = parseInt(element.pivot.volume)
                    element['id']= element.pivot.message_id
                    element['av_duration'] = 0.00
                    element['message_length'] = element.pivot.message_length
                    element['message_length_display'] = element.pivot.message_length_display
                });
            }
            this.editedItem.interval = parseInt(item.interval)
            
            this.dialog = true
            
        },
        deleteItem(item){
            this.shouldDeleteItem = null
            this.shouldDeleteItem = item
            this.deleteDialog = true
        },
        confirmDelete(){
            const index = this.playlists.indexOf(this.shouldDeleteItem)
            axios.delete('playlist/'+this.shouldDeleteItem.id,{
                params:{
                    token: this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
                })
                .then(response=>{
                    this.$store.dispatch('setAlert', response.data.message)
                    this.playlists.splice(index, 1)
                    this.deleteDialog = false
                })
        },
        deleteDialogClose(){
            this.shouldDeleteItem=null
            this.deleteDialog = false
        },
        save(){
            if(!this.$refs.messageForm.validate()) return

            if(this.editedIndex == -1){
                let data = {
                    name: this.editedItem.name,
                    uploaded_by: this.editedItem.uploaded_by,
                    messages: this.editedItem.messages,
                    interval: this.editedItem.interval
                }
                console.log(data.messages)
                axios.post('playlist', data,{
                    params:{
                        token: this.$store.getters.getToken,
                        user_id: this.$store.getters.getUser
                    }
                })
                .then(response=>{
                    this.playlists = response.data.playlists

                    this.playlists.sort(function(a, b){
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at)
                        if(keyA > keyB) return -1
                        if(keyA < keyB) return 1
                        return 0
                    })
                    this.$refs.messageForm.reset()
                    this.dialog = false
                    this.$store.dispatch('setAlert', response.data.message)
                })
                .catch(error=>{
                    console.log(error.response)
                })
            }else{

                if(this.editedItem.messages[this.editedItem.messages.length - 1].id == 0){
                    this.validPlaylist = 0
                    let el = document.getElementsByClassName('message0')
                    el[0].classList.add('without-message')
                    return 
                }else{
                    this.validPlaylist = 1
                }

                let data = {
                    name: this.editedItem.name,
                    uploaded_by: this.editedItem.uploaded_by,
                    messages: this.editedItem.messages,
                    interval: this.editedItem.interval
                }
                axios.put('playlist/'+this.editedItem.id, data,{
                    params:{
                        token: this.$store.getters.getToken,
                        user_id: this.$store.getters.getUser
                    }
                })
                .then(response=>{
                    
                    this.playlists = response.data.playlists

                    this.playlists.sort(function(a, b){
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at)
                        if(keyA > keyB) return -1
                        if(keyA < keyB) return 1
                        return 0
                    })
                    this.$refs.messageForm.reset()
                    this.dialog = false
                    this.$store.dispatch('setAlert', response.data.message)
                })
                .catch(error=>{
                    console.log(error.response)
                })
            }
            
        },
        download(name){

            let BASE_URL = ''
            if(location.hostname == 'localhost'){
                BASE_URL = 'http://www.gdir.local/admin'
            }else if(location.hostname == 'siriusxm4biz.com' || location.hostname == 'www.siriusxm4biz.com'){
                BASE_URL = 'https://gapi.gracedigital.com/admin'
            }else if(location.hostname == 'staging.gracedigital.com'){
                BASE_URL = 'https://staginapi.gracedigital.com/admin'
            }else if(location.hostname == 'sxbr3.siriusxm4biz.com'){
                BASE_URL = 'https://sxbr3api.gracedigital.com/admin'
            }

            let link=BASE_URL+'message/download/'+name+'?token='+this.$store.getters.getToken
            window.open(link, '_self')

        },
        close(){
            this.dialog = false
            setTimeout(()=>{
                // this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                this.dialogTitle = 'Add Message Playlist'
                this.$refs.messageForm.reset()
                this.$refs.messageForm.resetValidation()
            },100)
        },
        getPlaylist(){
            axios.get('playlist',
            {
                params:{
                    token: this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
            })
            .then(response=>{ 
                this.playlists = response.data.playlists
                this.playlists.sort(function(a, b){
                    var keyA = new Date(a.created_at),
                        keyB = new Date(b.created_at)
                    if(keyA > keyB) return -1
                    if(keyA < keyB) return 1
                    return 0
                })

            })
        },
        getAudioFiles(){
            axios.get('message',
            {
                params:{
                    token:this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
            })
            .then(response=>{ 
                this.audioFiles = response.data.messages
                this.audioFiles.sort(function(a, b){
                    var keyA = new Date(a.created_at),
                        keyB = new Date(b.created_at)
                    if(keyA > keyB) return -1
                    if(keyA < keyB) return 1
                    return 0
                })
                
            })
        },
        closePlaylistDialog(){
            this.newPlayListDialog = false
            setTimeout(()=>{
                this.$refs.playListAddForm.reset()
            }, 100)
        },
        getParmas(item){
            if(item){
                return item.id
            }else{
                return 0
            }
        },
        getUser(){
            return this.$store.getters.getUser
        }
    },
    created(){
        this.getPlaylist()

        this.getAudioFiles()
        
        localStorage.setItem('previousUrl', localStorage.getItem('currentUrl'))
        localStorage.setItem('currentUrl', '/admin/playlist');
    },
    watch:{
        
        $route(to, from) {
            if(from.params.id != to.params.id){
               if(!this.$store.getters.getWorkingAs){
                    this.workingAsAdmin = false
                }else{
                    this.workingAsAdmin = true
                }
            }
        }
    },
    computed:{
        headers(){
            return [
                { text: 'Message Playlist Name', value: 'name'},
                { text: 'Playlist Duration', value: 'duration'},
                { text: 'Interval', value: 'interval'},
                { text: 'Created by', value:'uploaded_by'},
                { text: 'Date Saved', value: 'updated_at', width: '15%'},
                { text: 'Action', value: 'actions', width: '17%'}
            ]
        }
    }
}
</script>
<style scoped>
    .v-breadcrumbs {
    background-color: #0f4e74;
    padding: 6px 8px;
    color: #fff; 
    }

    .v-breadcrumbs__item {
    color: #fff;
    }

    .text-start{
        font-size: 34px !important;
    }

    .subtitle {
    color: #314b5f;
    }
    .v-card__text, .v-card__title {
    padding: 0px 16px;
}
</style>